import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Hero from './Hero'
import Features from './Features'
import FAQ from './FAQ'

const LandingPage: React.FC = () => {
  const location = useLocation()
  const [scrollProgress, setScrollProgress] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      const docHeight = document.documentElement.scrollHeight - window.innerHeight
      setScrollProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if ((location.state as any)?.scrollTo) {
      setTimeout(() => {
        const element = document.getElementById((location.state as any).scrollTo)
        if (element) {
          const offset = 80
          const elementPosition = element.getBoundingClientRect().top
          const offsetPosition = elementPosition + window.pageYOffset - offset
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
        }
      }, 100)
    }
  }, [location])

  return (
    <>
      {/* Scroll progress bar */}
      <div className="fixed top-0 left-0 w-full h-[2px] z-[9999]">
        <div
          className="h-full"
          style={{
            width: `${scrollProgress}%`,
            background: 'linear-gradient(to right, #e11d48, #f97316)',
            transition: 'width 50ms linear',
          }}
        />
      </div>

      {/* Hero Section */}
      <Hero />

      {/* Features Section */}
      <section className="relative">
        <Features />
      </section>

      {/* FAQ Section */}
      <section className="relative">
        <FAQ />
      </section>
    </>
  )
}

export default LandingPage
